import React, { useState } from 'react';
import {useLoginBackgroundStyle} from '../utilities/loginBackground';
import { Link } from 'react-router-dom';
import {useBrandLogo} from '../utilities/genreIcons';
import { MdAlternateEmail } from 'react-icons/md';
import Swal from 'sweetalert2';
import './LoginForm.css';

const ForgotPassword = () => {
    const loginBgStyle = useLoginBackgroundStyle();
    const ddLogo = useBrandLogo();
    const [email, setEmail] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async e => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await fetch(`${process.env.REACT_APP_API_PROXY}/auth/forgot-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });
            setSubmitted(true);
        } catch {
            Swal.fire({ timer: 2000, title: 'Error', text: 'Could not reach the server. Please try again later.', icon: 'error' });
        } finally {
            setSubmitting(false);
        }
    };

    if (submitted) {
        return (
            <div className="login" style={loginBgStyle}>
                <div className="wrapper" style={{ textAlign: 'center' }}>
                    <img src={ddLogo} alt="DD_Logo" className="brand-logo brand-logo--lg"/>
                    <h2 style={{ margin: '20px 0 10px', fontSize: '22px' }}>Check your email</h2>
                    <p style={{ fontSize: '14px', marginBottom: '20px', lineHeight: '1.6' }}>
                        If an account exists for <strong>{email}</strong>, we've sent a password reset link.
                        Click the link to choose a new password.
                    </p>
                    <div className="register-link">
                        <p><Link to="/">Log in</Link></p>
                    </div>
                </div>
                <div className="copyright-footer">
                    &copy; {new Date().getFullYear()} Virtual Realms Studios, LLC. All rights reserved.
                </div>
            </div>
        );
    }

    return (
        <div className="login" style={loginBgStyle}>
            <div className="wrapper">
                <form onSubmit={handleSubmit}>
                    <img src={ddLogo} alt="DD_Logo" className="brand-logo brand-logo--lg"/>
                    <h2 style={{ margin: '0 0 10px', fontSize: '20px', textAlign: 'center' }}>Forgot your password?</h2>
                    <p style={{ fontSize: '13px', textAlign: 'center', marginBottom: '16px', lineHeight: '1.5' }}>
                        Enter your email and we'll send you a link to reset your password.
                    </p>
                    <div className="input-box">
                        <input
                            type="text"
                            placeholder='Email'
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            required
                        />
                        <MdAlternateEmail className="icon"/>
                    </div>
                    <button type="submit" disabled={submitting}>
                        {submitting ? 'Sending…' : 'Send Reset Link'}
                    </button>
                    <div className="register-link" style={{ marginTop: '16px' }}>
                        <p>Remembered your password? <Link to="/">Log in</Link></p>
                    </div>
                </form>
            </div>
            <div className="copyright-footer">
                &copy; {new Date().getFullYear()} Virtual Realms Studios, LLC. All rights reserved.
            </div>
        </div>
    );
};

export default ForgotPassword;
